module.exports = __webpack_public_path__ + "img/lg_grupo_w.acda46e4.png";